import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[mapSidebar]' })
export class MapSidebarDirective {
    constructor(public tpl: TemplateRef<any>) {}
}
